import PropTypes from 'prop-types';

const children = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.object,
    PropTypes.func,
    PropTypes.arrayOf(PropTypes.func),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};

const router = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default {
  children,
  router
}
